import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getChannels = createAsyncThunk(
  '/getChannels',
  async () => {
    const response = await axios.get('/GetChannels');
    return response.data;
  }
);

export const getChannelDetails = createAsyncThunk(
  '/getChannelDetails',
  async (id) => {
    const response = await axios.get(`/GetChannelDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const channelSlice = createSlice({
  name: 'channel',
  initialState: {
    loading: false,
    error: '',
    Channels: [],
    ChannelDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.ChannelDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getChannels.pending]: (state) => {
      state.loading = true;
    },
    [getChannels.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getChannels.fulfilled]: (state, action) => {
      state.Channels = action.payload;
      state.loading = false;
    },
    [getChannelDetails.pending]: (state) => {
      state.loading = true;

    },
    [getChannelDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getChannelDetails.fulfilled]: (state, action) => {
      state.ChannelDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.ChannelDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const channelActions = channelSlice.actions;

export default channelSlice;
